import * as sup from "superstruct";

import {
  createIdentifierStruct,
  createResourceStruct,
} from "@/modules/api/utils/jsonApiStructs";
import { attachmentResourceType } from "@/modules/attachment/attachmentResourceConsts";

import { tutorialStepIdentifierStruct } from "./tutorialStepIdentifierStruct";
import { handbookResourceType } from "./tutorialStepResourceConsts";

export const tutorialStepResourceStruct = createResourceStruct({
  identifier: tutorialStepIdentifierStruct,
  attributes: sup.object({
    name: sup.string(),
    description: sup.string(),
    videoLink: sup.nullable(sup.string()),
  }),
  relationships: sup.object({
    handbook: sup.object({
      data: sup.nullable(createIdentifierStruct(handbookResourceType)),
    }),
    attachments: sup.object({
      data: sup.array(createIdentifierStruct(attachmentResourceType)),
    }),
  }),
});

export type TutorialStepResource = sup.Infer<typeof tutorialStepResourceStruct>;
